import { useContext } from 'react';
import { LanguageContext } from '../components/language/LanguageContext';

// Re-export LanguageContext for direct access if needed
export { LanguageContext };

/**
 * Hook to access translations
 * @returns {Function} Translation function t(key) that returns the translated string
 * 
 * @example
 * const t = useTranslation();
 * const text = t('navigation.personalCredit'); // Returns "Personal Credit" or "Crédito Personal"
 */
export const useTranslation = () => {
  const context = useContext(LanguageContext);
  
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }

  const { translations, language } = context;

  /**
   * Translation function
   * @param {string} key - Dot-separated key path (e.g., 'navigation.personalCredit')
   * @param {string} defaultValue - Optional default value if key is not found
   * @returns {string} Translated string
   */
  const t = (key, defaultValue = '') => {
    if (!translations) {
      return defaultValue || key;
    }

    const keys = key.split('.');
    let value = translations;

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Key not found, return default or the key itself
        return defaultValue || key;
      }
    }

    return typeof value === 'string' ? value : (defaultValue || key);
  };

  return t;
};

